import React from 'react';
import styled from 'styled-components';

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.foreground};
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Select = styled.select`
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  border: 2px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.foreground};
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 500;
  cursor: pointer;
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

const Meta = styled.span`
  font-size: ${({ theme }) => theme.fontClamp.sm};
  color: ${({ theme }) => theme.colors.mutedForeground};
  margin-left: auto;
`;

export const SORT_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'title-asc', label: 'Title A–Z' },
  { value: 'title-desc', label: 'Title Z–A' },
];

export function sortItems(items, sortBy) {
  if (!items || !items.length) return items;
  const copy = [...items];
  if (sortBy === 'title-asc') copy.sort((a, b) => (a.title || '').localeCompare(b.title || '', 'en', { sensitivity: 'base' }));
  if (sortBy === 'title-desc') copy.sort((a, b) => (b.title || '').localeCompare(a.title || '', 'en', { sensitivity: 'base' }));
  return copy;
}

export default function SortBar({ sortBy, onSortChange, totalItems, page, pageSize }) {
  const start = totalItems === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  return (
    <Bar>
      <Label>
        Sort by
        <Select value={sortBy} onChange={(e) => onSortChange(e.target.value)} aria-label="Sort order">
          {SORT_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Select>
      </Label>
      <Meta>
        {totalItems === 0 ? '0 titles' : `Showing ${start}–${end} of ${totalItems} titles`}
      </Meta>
    </Bar>
  );
}
